<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    multiple
    chips
    deletable-chips
    small-chips
    item-text="descricao"
    label="Projeto"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <v-list-item-content>
        <v-list-item-title>
          <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
          {{ item.item.descricao }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        {{ item.item.descricao }}
        <v-btn small icon @click="onRemoveItem(item.index)">
          <v-icon small class="mb-1">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import ProjetoService from '@/api/projeto-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
    grupoId: [String, Number],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    searchItems(val) {
      const searchValue = val ? val.toLowerCase() : '';

      this.loading = true;
      ProjetoService.getProjetos({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `ativo is true and (descricao like "%${searchValue}%" or codigoInterno like "%${searchValue}%")`,
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
    onRemoveItem(index) {
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
